export interface TranslationEntry {
  message: string;
  description: string;
}

const enVisibilitySection: Record<string, TranslationEntry> = {
  "page.settings.makePublicTitle": {
    message: "Make this ledger public?",
    description:
      "Title of the confirmation before a private ledger becomes public",
  },
  "page.settings.makePublicDescription": {
    message:
      "Anyone with the link, and search engines, will be able to see this ledger's transactions, balances, files and history.",
    description: "What becomes visible when a private ledger is made public",
  },
  "page.settings.makePublic": {
    message: "Make public",
    description: "Button that confirms making a private ledger public",
  },
  "page.settings.publicLedger": {
    message: "Public Ledger",
    description: "Label when ledger is public",
  },
  "page.settings.publicLedgerDescription": {
    message: "Your ledger is public. Anyone with the link can view it.",
    description: "Description for public ledger state",
  },
  "page.settings.embedCode": {
    message: "Embed Code",
    description: "Label for embed code field",
  },
  "page.settings.copied": {
    message: "Copied!",
    description: "Confirmation message when text is copied",
  },
  "page.settings.visibility": {
    message: "Visibility",
    description: "Section title for visibility settings",
  },
  "page.settings.visibilityDescription": {
    message: "Control who can access your ledger",
    description: "Description for visibility settings section",
  },
  "page.settings.sharingDescription": {
    message: "Share your public ledger with others",
    description: "Description for sharing settings section",
  },
  "page.settings.shareableUrl": {
    message: "Shareable URL",
    description: "Label for shareable URL field",
  },
  "page.settings.sharing": {
    message: "Public Sharing",
    description: "Subsection title for public sharing options",
  },
  "page.settings.privateLedgerDescription": {
    message:
      "Your ledger is private. Only you and collaborators can access it.",
    description: "Description for private ledger state",
  },
  "page.settings.privateLedger": {
    message: "Private Ledger",
    description: "Label when ledger is private",
  },
  "page.settings.embedViewOnBeancount": {
    message: "View on Beancount.io",
    description:
      "Link label in the generated embed code pointing back to Beancount.io",
  },
  "page.settings.copyUrlFailed": {
    message: "Failed to copy URL",
    description: "Toast when copying the shareable URL failed",
  },
  "page.settings.copyCodeFailed": {
    message: "Failed to copy code",
    description: "Toast when copying the embed code failed",
  },
  "page.settings.copyShareableUrl": {
    message: "Copy shareable URL",
    description: "Accessible name for the button that copies the shareable URL",
  },
  "page.settings.copyEmbedCode": {
    message: "Copy embed code",
    description: "Accessible name for the button that copies the embed code",
  },
  "page.settings.visibilityDescriptionReadOnly": {
    message: "Who can access this ledger. Only ledger admins can change it.",
    description:
      "Visibility section description shown to viewers who cannot change it",
  },
  "page.settings.publicLedgerDescriptionReadOnly": {
    message: "This ledger is public. Anyone with the link can view it.",
    description:
      "Public ledger state described to viewers who cannot change it",
  },
  "page.settings.privateLedgerDescriptionReadOnly": {
    message:
      "This ledger is private. Only its owner and collaborators can access it.",
    description:
      "Private ledger state described to viewers who cannot change it",
  },
};

export default enVisibilitySection;
